import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store';

import Autocomplete from './components/autocomplete/Autocomplete';
import Basket from './components/basket/Basket';
import BasketPhone from './components/basket/BasketPhone';
import BasketPage from './pages/basket/BasketPage';
import SearchPage from './pages/search/SearchPage';
import ProductsPage from './pages/product/ProductsPage';
import TopProducts from './pages/product/TopProducts';
import AddToCart from './pages/productDetail/AddToCart';

import OutOfStock from './components/product/OutOfStock';
import PriceIsNotFinal from './components/product/PriceIsNotFinal';
import PriceOnRequest from './components/product/PriceOnRequest';

import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

// Helper function for rendering components
const renderComponent = (selector, Component, withStore = false) => {
    const container = document.querySelector(selector);
    if (container) {
        const root = createRoot(container);
        const element = withStore ? (
            <Provider store={store}>
                <I18nextProvider i18n={i18n}>
                    <Component />
                </I18nextProvider>
            </Provider>
        ) : (
            <I18nextProvider i18n={i18n}>
                <Component />
            </I18nextProvider>
        );
        root.render(element);
    }
};

// Common components
renderComponent('#search-input-form', Autocomplete, true);
renderComponent('#basket-menu-item', Basket, true);
renderComponent('#basket-menu-item-phone', BasketPhone, true);

// Conditional renders
if (document.querySelector('#search-page')) {
    renderComponent('#search-page', SearchPage, true);
}

if (document.querySelector('#products-page')) {
    renderComponent('#products-page', ProductsPage, true);
}

if (document.querySelector('.product-detail')) {
    renderComponent('#outOfStock', OutOfStock);
    renderComponent('#priceOnRequest', PriceOnRequest);
    renderComponent('#priceIsNotFinal', PriceIsNotFinal);
    renderComponent('#add-to-cart', AddToCart, true);
}

if (document.querySelector('#basket-page')) {
    renderComponent('#basket-page', BasketPage, true);
}

if (document.querySelector('#top-products')) {
    renderComponent('#top-products', TopProducts, true);
}
